import {DomesticRoadShipmentGoodAdr, type ShipmentGoodAdrData} from "@/types/shipments/Domestic/DomesticRoadShipmentGoodAdr.ts";

export class DomesticRoadShipmentGood {
    public id:number|null;
    public domestic_shipment_id:number;
    public shipment_goods_seq:number;
    public quantity:number|null;
    public package_code:string|null;
    public packing_name:string|null;
    public description:string|null;
    public weight:number|null;
    public length:number|null;
    public width:number|null;
    public height:number|null;
    public ldm:number|null;
    public volume:number|null;
    public adrs:DomesticRoadShipmentGoodAdr[];

    constructor(data:DomesticRoadShipmentGoodData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.domestic_shipment_id = 0;
            this.shipment_goods_seq = 0;
            this.quantity = null;
            this.package_code = null;
            this.packing_name = null;
            this.description = null;
            this.weight = null;
            this.length = null;
            this.width = null;
            this.height = null;
            this.ldm = null;
            this.volume = null;
            this.adrs = [];
        }
        else
        {
            this.id = data.id;
            this.domestic_shipment_id = data.domestic_shipment_id;
            this.shipment_goods_seq = data.shipment_goods_seq;
            this.quantity = data.quantity;
            this.package_code = data.package_code;
            this.packing_name = data.packing_name;
            this.description = data.description;
            this.weight = data.weight;
            this.length = data.length;
            this.width = data.width;
            this.height = data.height;
            this.ldm = data.ldm;
            this.volume = data.volume;
            this.adrs = [];
            if(data.adrs !== undefined && data.adrs !== null)
            {
                data.adrs.forEach(adr => {
                    this.adrs.push(new DomesticRoadShipmentGoodAdr(adr));
                })
            }
        }
    }
}

export type DomesticRoadShipmentGoodData = {
    id:number|null;
    domestic_shipment_id:number;
    shipment_goods_seq:number;
    quantity:number|null;
    package_code:string|null;
    packing_name:string|null;
    description:string|null;
    weight:number|null;
    length:number|null;
    width:number|null;
    height:number|null;
    ldm:number|null;
    volume:number|null;
    adrs:ShipmentGoodAdrData[]|undefined;
}
